import React, {Component} from 'react';
import {Container, Message, Form, List} from 'semantic-ui-react';
import localDB from "../../data/localDB";
import CustomDivider from "../extras/CustomDivider";
import TicketItem from "./TicketItem";
import connect from "react-redux/es/connect/connect";
import TicketData from "../../data/TicketData";
import {ticketDialog} from "../../actions/TicketDialogActions";
import {showToast} from "../../actions/ToastAction";
import {selectTicket} from "../../actions/TicketSelectActions";
import {dynamicTableAddOrUpdate} from "../../actions/DynamicTableDataAction";

class TicketProducts extends Component {
    constructor(){
        super();
        this.state = {
            options:[],
        }
    }

    componentWillMount(){
        localDB.getDB('products').then(products => {
            let options = products.map(product => {return {key:product.id, value:product.id, text:product.name}});
            this.setState({options});
        });
    }

    handleProductChange = (e, {value}) => {
        this.setState({product:value, product_error:false});
    };

    handleProductQuantityChange = (event) => {
        this.setState({quantity:event.target.value, quantity_error:false});
    };

    handleAddProduct = () =>{
        if(this.state.product === ''){
            this.setState({product_error:true});
        }else if(this.state.quantity <= 0){
            this.setState({quantity_error:true});
        }else {
            this.setState({loading_add:true});
            let data = {
                product: this.state.product,
                quantity: this.state.quantity,
                ticket: this.props.ticket_select.id
            };

            TicketData.productAdd(data, (res) => {
                if (res.add) {
                    let ticket = this.props.ticket_select;
                    let products = this.props.ticket_select.products.slice();
                    products.unshift(res.data);
                    ticket.products = products;
                    this.handleDispatch(ticket);
                    this.setState({quantity:''});
                } else {
                    this.props.showToast({
                        show:true,
                        type:'error',
                        message:'El producto ya está registrado!'
                    });
                }
                this.setState({loading_add:false});
            });
        }
    };

    handleDispatch = (ticket) =>{
        this.props.selectTicket(ticket);
        this.props.dynamicTableAddOrUpdate(ticket);
    };

    render() {
        return (
            <Container>
                {this.props.ticket_select.id ? <Container>
                    <Form.Group>
                        <Form.Dropdown
                            label='Producto'
                            options={this.state.options}
                            error={this.state.product_error}
                            placeholder='Producto'
                            onChange={this.handleProductChange}
                            search
                            selection
                        />
                        <Form.Input
                            label='Cant.'
                            placeholder='Cant.'
                            type='number'
                            min={0}
                            value={this.state.quantity}
                            error={this.state.quantity_error}
                            onChange={this.handleProductQuantityChange}
                        />
                        <Form.Button
                            circular
                            label='&nbsp;'
                            icon='add'
                            primary
                            onClick={()=>this.handleAddProduct()}
                            loading={this.state.loading_add}
                            disabled={this.state.loading_add}
                        />
                    </Form.Group>
                    <CustomDivider/>
                    <div className='modal-content-scroll' style={{height:this.state.height}}>
                        <div>
                            {
                                this.props.ticket_select.products.length === 0 ? <Message icon='bell' header='No hay información registrada'/> :
                                    <List divided>
                                        {this.props.ticket_select.products.map(item => {
                                            return <TicketItem {...item} key={item.id}/>
                                        })}
                                    </List>
                            }
                        </div>
                    </div>
                </Container>:<Message
                    icon='bell'
                    header='Para agregar productos, primero debe GUARDAR.'
                />}
            </Container>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ticketDialog(data) {
            dispatch(ticketDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectTicket(data){
            dispatch(selectTicket(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        }
    }
}

function mapStateToProps(state) {
    return {
        ticket_select: state.get('ticket_select'),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketProducts)


// WEBPACK FOOTER //
// ./src/components/services/TicketProducts.js